'use strict';

exports.__esModule = true;
exports.default = createHistory;

var _redux = require('redux');

var _Actions = require('./Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _createHistoryEnhancer = require('./createHistoryEnhancer');

var _createHistoryEnhancer2 = _interopRequireDefault(_createHistoryEnhancer);

var _createStoreHistory = require('./createStoreHistory');

var _createStoreHistory2 = _interopRequireDefault(_createStoreHistory);

var _locationReducer = require('./locationReducer');

var _locationReducer2 = _interopRequireDefault(_locationReducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createHistory(options) {
  var store = (0, _redux.createStore)(_locationReducer2.default, (0, _createHistoryEnhancer2.default)(options));
  store.dispatch(_Actions2.default.init());

  return (0, _createStoreHistory2.default)(store, function (location) {
    return location;
  });
}
module.exports = exports['default'];